<footer class="br-footer">
   <div class="container-lg">
      <div class="logo">
         <img src="../../assets/images/govbr-white.png" alt="Imagem" />
      </div>
      <div
         class="br-list horizontal"
         data-toggle="data-toggle"
         data-sub="data-sub"
      >
         <div class="col-2">
            <span class="br-item header" (click)="toggleMenu('institucional')">
               <div class="content text-down-01 text-bold text-uppercase">
                  INSTITUCIONAL
               </div>
               <div class="support">
                  <i
                     class="fas fa-angle-down"
                     [ngClass]="{ rotate: activeMenu === 'institucional' }"
                     aria-hidden="true"
                  ></i>
               </div>
            </span>
            <div
               id="institucional"
               class="br-list"
               collapse
               [ngClass]="{ active: activeMenu === 'institucional' }"
            >
               <a class="br-item" (click)="linkPrincipal()">
                  <div class="content">Página Inicial</div>
               </a>
               <a class="br-item" (click)="linkApresentacao()">
                  <div class="content">Apresentação</div>
               </a>
               <a class="br-item" (click)="linkLegislacao()">
                  <div class="content">Legislação</div>
               </a>
               <a class="br-item" (click)="linkFAQ()">
                  <div class="content">Perguntas frequentes</div>
               </a>
               <a class="br-item" (click)="linkExpediente()">
                  <div class="content">Expediente</div>
               </a>
            </div>
         </div>

         <div class="col-2">
            <span class="br-item header" (click)="toggleMenu('curso')">
               <div class="content text-down-01 text-bold text-uppercase">
                  ENCONTRE UM CURSO
               </div>
               <div class="support">
                  <i
                     class="fas fa-angle-down"
                     [ngClass]="{ rotate: activeMenu === 'curso' }"
                     aria-hidden="true"
                  ></i>
               </div>
            </span>
            <div
               id="curso"
               class="br-list"
               collapse
               [ngClass]="{ active: activeMenu === 'curso' }"
            >
               <a class="br-item" (click)="linkTodosCursos()">
                  <div class="content">Todos os cursos</div>
               </a>
               <a class="br-item" [routerLink]="['/']" fragment="cursoPorEixo">
                  <div class="content">Cursos por eixo tecnológico</div>
               </a>
               <a
                  class="br-item"
                  [routerLink]="['/cursos/mudaram-nome-tabela-convergencia']"
               >
                  <div class="content">Tabela de Convergência</div>
               </a>
               <a class="br-item" [routerLink]="['/cursos/tabela-submissao']">
                  <div class="content">Tabela de Submissão</div>
               </a>
            </div>
         </div>

         <div class="col-2">
            <span class="br-item header" (click)="toggleMenu('downlods')">
               <div class="content text-down-01 text-bold text-uppercase">
                  DOWNLOADS
               </div>
               <div class="support">
                  <i
                     class="fas fa-angle-down"
                     [ngClass]="{ rotate: activeMenu === 'downlods' }"
                     aria-hidden="true"
                  ></i>
               </div>
            </span>
            <div
               id="downlods"
               class="br-list"
               collapse
               [ngClass]="{ active: activeMenu === 'downlods' }"
            >
               <a
                  class="br-item"
                  target="_blank"
                  rel="noreferrer"
                  href="{{ linkCatalogoPdf }}"
               >
                  <div class="content">Catálogo em PDF</div>
               </a>
               <a class="br-item" (click)="downloadCsvCatalogoCncst()">
                  <div class="content">Catálogo em CSV</div>
               </a>
               <a
                  class="br-item"
                  target="_blank"
                  rel="noreferrer"
                  href="{{ linkDadosAtualizadosPdf }}"
               >
                  <div class="content">Registro de alterações no portal</div>
               </a>
            </div>
         </div>

         <div class="col-2">
            <span class="br-item header" (click)="toggleMenu('melhoria')">
               <div class="content text-down-01 text-bold text-uppercase">
                  AJUDE A MELHORAR O CATÁLOGO
               </div>
               <div class="support">
                  <i
                     class="fas fa-angle-down"
                     [ngClass]="{ rotate: activeMenu === 'melhoria' }"
                     aria-hidden="true"
                  ></i>
               </div>
            </span>
            <div
               id="melhoria"
               class="br-list"
               collapse
               [ngClass]="{ active: activeMenu === 'melhoria' }"
            >
               <a class="br-item" [routerLink]="['/envie-sugestao']">
                  <div class="content">Envie sua sugestão de melhoria</div>
               </a>
            </div>
         </div>

         <div class="col-2">
            <span class="br-item header" (click)="toggleMenu('fale-conosco')">
               <div class="content text-down-01 text-bold text-uppercase">
                  CANAIS DE COMUNICAÇÃO
               </div>
               <div class="support">
                  <i
                     class="fas fa-angle-down"
                     [ngClass]="{ rotate: activeMenu === 'fale-conosco' }"
                     aria-hidden="true"
                  ></i>
               </div>
            </span>
            <div
               id="fale-conosco"
               class="br-list"
               collapse
               [ngClass]="{ active: activeMenu === 'fale-conosco' }"
            >
               <a
                  class="br-item"
                  target="_blank"
                  rel="noopener"
                  href="https://www.gov.br/mec/pt-br/canais_atendimento/fale-conosco"
               >
                  <div class="content">Fale Conosco</div>
               </a>
            </div>
         </div>

         <div class="col-2">
            <span class="br-item header" (click)="toggleMenu('links-externos')">
               <div class="content text-down-01 text-bold text-uppercase">
                  LINKS EXTERNOS
               </div>
               <div class="support">
                  <i
                     class="fas fa-angle-down"
                     [ngClass]="{ rotate: activeMenu === 'links-externos' }"
                     aria-hidden="true"
                  ></i>
               </div>
            </span>

            <div
               id="links-externos"
               class="br-list"
               collapse
               [ngClass]="{ active: activeMenu === 'links-externos' }"
            >
               <a
                  class="br-item"
                  target="_blank"
                  rel="noopener"
                  href="http://cnct.mec.gov.br/"
               >
                  <div class="content">
                     Catálogo Nacional de Cursos Técnicos (CNCT)
                  </div>
               </a>
               <a
                  class="br-item"
                  target="_blank"
                  rel="noopener"
                  href="http://www.mtecbo.gov.br/cbosite/pages/home.jsf"
               >
                  <div class="content">
                     Classificação Brasileira de Ocupações (CBO)
                  </div>
               </a>
            </div>
         </div>
      </div>

      <div class="d-none d-sm-block">
         <div class="row align-items-end justify-content-between py-5">
            <div class="col">
               <div class="social-network">
                  <div class="social-network-title">Redes Sociais</div>
                  <div class="d-flex">
                     <a
                        class="br-button circle"
                        href="https://twitter.com/min_educacao"
                        aria-label="Compartilhar por Twitter"
                        target="_blank"
                        rel="noopener"
                        ><i class="fab fa-x-twitter" aria-hidden="true"></i
                     ></a>
                     <a
                        class="br-button circle"
                        href="https://www.youtube.com/user/ministeriodaeducacao"
                        aria-label="Compartilhar por YouTube"
                        target="_blank"
                        rel="noopener"
                        ><i class="fab fa-youtube" aria-hidden="true"></i
                     ></a>
                     <a
                        class="br-button circle"
                        href="https://www.facebook.com/ministeriodaeducacao/"
                        aria-label="Compartilhar por Facebook"
                        target="_blank"
                        rel="noopener"
                        ><i class="fab fa-facebook-f" aria-hidden="true"></i
                     ></a>
                     <a
                        class="br-button circle"
                        href="https://www.instagram.com/mineducacao/"
                        aria-label="Compartilhar por Instagram"
                        target="_blank"
                        rel="noopener"
                        ><i class="fab fa-instagram" aria-hidden="true"></i
                     ></a>
                     <!-- TODO inserir outras redes sociais -->
                  </div>
               </div>
            </div>

            <div class="col assigns text-right">
               <a
                  href="http://www.gov.br/acessoainformacao/"
                  target="_blank"
                  rel="noopener"
               >
                  <img
                     class="ml-4"
                     src="../../assets/images/acesso-informacao-white.png"
                     alt="Acesso à Informação"
               /></a>
               <a
                  href="https://www.gov.br/mec/pt-br"
                  target="_blank"
                  rel="noopener"
               >
                  <img
                     class="ml-4"
                     src="../../assets/images/mec-white.png"
                     alt="Ministério da Educação"
               /></a>
            </div>
         </div>
      </div>
   </div>
   <span class="br-divider my-3"></span>
   <div class="container-lg">
      <div class="info">
         <div class="text-down-01 text-medium pb-3">
            Todo o conteúdo deste site está publicado sob a licença
            <strong
               ><a
                  href="https://creativecommons.org/licenses/by-nd/3.0/deed.pt_BR"
                  >Creative Commons Atribuição-SemDerivações 3.0 Não Adaptada</a
               ></strong
            >.
         </div>
      </div>
   </div>
</footer>
